import { GithubOutlined } from '@ant-design/icons';
import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright="Powered by franksoft"
      links={[
        {
          key: 'Ant Design Pro',
          title: 'Ant Design Pro',
          href: 'https://pro.ant.design',
          blankTarget: true,
        },
        {
          key: 'github',
          title: <GithubOutlined />,
          href: 'https://github.com/frankSoft365/frank-api-frontend#',
          blankTarget: true,
        },
        {
          key: 'frankSoft',
          title: 'frankSoft',
          href: 'https://github.com/frankSoft365',
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
